import * as StyleFunctions from '../utilities/StyleFunctions';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import Contents from './Contents';

export default function App(props){
	var currentList = props.currentList;
	var width = props.width;
	var height = props.height;
	var itemPath = props.itemPath;
	var internalVariables = props.internalVariables;
	var error = props.error;
	var itemEdited = props.itemEdited;
	var setItemClicked = props.setItemClicked;
	var onClickItemChangeSelection = props.onClickItemChangeSelection;
	var organicChanges = props.organicChanges;
	var userNos = props.userNos;
	var userID = props.userID;
	var updatesToPropagate = props.updatesToPropagate;
	var inputValues = props.inputValues;
	var ownVariables = props.ownVariables;
	var urlParamsForExecution = props.urlParamsForExecution;
	var urlHeader = props.urlHeader;
	var chains = props.chains;
	var className = props.className;
	var styleWrap = props.styleWrap;
	var type1 = 'DIV'
	var refObject = props.refObject;
	var getRef1 = props.getRef1;
	var icon = '';
	var interactionFn = props.interactionFn;
	var dragStuff = props.dragStuff;
	var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
	var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
	var upwardInfo = props.upwardInfo;
	var hoveringWhere = props.hoveringWhere;
	var actHoveringWhere = props.actHoveringWhere;
	var doAScreenRef = props.doAScreenRef;
	var flashHighlight = props.flashHighlight;
	var counter = props.counter;


	var mainScreenPart = CoreFns.goDownPath(currentList, itemPath, 0);
	var doInputActions = ResponsiveFns.doInputActionsFn(itemPath, organicChanges, currentList, userID);
	var inside = {doInputActions, updatesToPropagate, doRef}

  var goToAnywhere = StyleFunctions.goToAnywhereFn(itemPath);

  function doRef(newRef){
    refObject[itemPath.join('_')] = newRef;
    getRef1(refObject);
  }

  function clickBeneath(e){
    goToAnywhere();
    setItemClicked(e);
  }

	var style1 = StyleFunctions.evaluateStyleR(type1, mainScreenPart.s, itemPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
	if (style1.borderWidth){
		delete styleWrap.border;
	}else{
		delete style1.borderColor;
		delete style1.borderStyle;
		delete style1.borderWidth;
	}


	var addCC = '';
  var toIt1 = ['mt', 'mb', 'ml', 'mr'];
  toIt1.forEach((aIt, index)=>{
    var name = aIt;
    if (style1[aIt]){
      addCC += ' ' + name + '-' + style1[aIt];
    }

  })

  var styleIn = {...styleWrap, ...style1};	
	var classNameOut = className + addCC;  

  return <Contents chains={chains} key={itemPath.join(' ')} itemPath={itemPath} width={width} height={height} currentList={currentList} organicChanges={organicChanges} userNos={userNos} interactionFn={interactionFn} internalVariables={internalVariables} styleIn={styleIn} inside={inside} clickBeneath={clickBeneath} setItemClicked={setItemClicked} inputValues={inputValues} error={error} itemEdited={itemEdited}  onClickItemChangeSelection={onClickItemChangeSelection} className={classNameOut} icon={icon} dragStuff={dragStuff} setIsShowingSomeDropDown={setIsShowingSomeDropDown} setIsClickingOnContentDiv={setIsClickingOnContentDiv} upwardInfo={upwardInfo} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere}  ownVariables={ownVariables} doAScreenRef={doAScreenRef} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} counter={counter}/>
}
